var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.3301V12.9967C13.3333 12.2895 13.0523 11.6112 12.5522 11.1111C12.0521 10.611 11.3739 10.3301 10.6666 10.3301H5.33329C4.62605 10.3301 3.94777 10.611 3.44767 11.1111C2.94758 11.6112 2.66663 12.2895 2.66663 12.9967V14.3301",
    stroke: "#5932EA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 7.66341C9.4728 7.66341 10.6667 6.4695 10.6667 4.99674C10.6667 3.52399 9.4728 2.33008 8.00004 2.33008C6.52728 2.33008 5.33337 3.52399 5.33337 4.99674C5.33337 6.4695 6.52728 7.66341 8.00004 7.66341Z",
    stroke: "#5932EA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.80525f60b0bb186ec41068ea093dd030.svg";
export { ForwardRef as ReactComponent };